"use client";

import React from "react";
import GenericSubstantiveProcedures from "../../substantive-procedures/GenericSubstantiveProcedures";

interface OpeningBalanceTestingSubstantiveProceduresProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
}

const WORKSPACE_NAME = "Opening Balance Testing";

export default function OpeningBalanceTestingSubstantiveProcedures({ onBack, setActiveSection }: OpeningBalanceTestingSubstantiveProceduresProps) {
  return (
    <GenericSubstantiveProcedures
      workspaceName={WORKSPACE_NAME}
      area="Execution"
      onBack={onBack}
      setActiveSection={setActiveSection}
    />
  );
}
